import { render } from "./KitchenZonePrintersRow.vue?vue&type=template&id=35157a4c"
import script from "./KitchenZonePrintersRow.vue?vue&type=script&lang=js"
export * from "./KitchenZonePrintersRow.vue?vue&type=script&lang=js"

import "./KitchenZonePrintersRow.vue?vue&type=style&index=0&id=35157a4c&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__